import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { CenteringDiv, FlexRowDiv, H1, P } from 'components/generic/HomePageComponents'
import { CareguideButton } from './Styled'

const CareGuide = ({ careguideImageUrl, careguideDescription, careguideHeader }) => (
  <FlexRowDiv bg='grey'>
    <CenteringDiv justifyContent='center'>
      <GenericLazyLoadImage
        src={careguideImageUrl}
        width={{ _: '320px', tablet: '350px', desktop: '450px' }}
        pt='50px'
      />
      <H1 m='0' fontSize={{ _: '35px', tablet: '40px' }} mt='20px'>
        {careguideHeader}
      </H1>
      <FlexRowDiv>
        <P
          m='0'
          fontSize='24px'
          textAlign={{ _: 'center', tablet: 'left' }}
          pt='20px'
          fontWeight='400'
          maxWidth='none'
          pb='20px'
        >
          {careguideDescription}
        </P>
      </FlexRowDiv>
      <CareguideButton href='/about'>Learn More</CareguideButton>
    </CenteringDiv>
  </FlexRowDiv>
)

export default CareGuide
